import { getApp, getApps, initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
    apiKey: 'AIzaSyA_os5LBdfVO_IexfqpfiTeYUoOPMP68UU',
    authDomain: 'toolproof-563fe.firebaseapp.com',
    projectId: 'toolproof-563fe',
    storageBucket: 'toolproof-563fe.appspot.com',
    messagingSenderId: '384484325421',
    appId: '1:384484325421:web:820785323cc2b5b1d9a0a4',
    measurementId: 'G-TSXX163NNS'
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig)
const db = getFirestore(app)
// Resources are stored in the dedicated bucket used by the backend integrations.
const storage = getStorage(app, 'gs://tp-resources')

export { db, storage }